"use strict";

/*
 * Reiter - ohne Bootstrap und ohne jQuery.
 *
 * Gebraucht fuer das Profilformular in bw_feusers, das seine Felder nach den
 * Reitern des Backends gruppiert. Bootstraps Reiter-Bauteil ist mit dem
 * uebrigen Bootstrap-JavaScript am 2026-09-01 gegangen; hier steht der Ersatz.
 *
 * Erwartet wird das Markup, das Edit.html erzeugt:
 *
 *   <div data-bw-reiter>
 *     <div role="tablist">
 *       <button role="tab" aria-controls="…" aria-selected="true|false">…</button>
 *     </div>
 *     <div role="tabpanel" id="…" hidden>…</div>
 *
 * Bedienung mit der Tastatur nach den ARIA-Regeln: Pfeil links/rechts wandert,
 * Pos1 und Ende springen an den Rand. Die nicht gewaehlten Knoepfe stehen auf
 * tabindex="-1", damit die Tabulatortaste die Leiste einmal betritt und dann
 * ins Formular weitergeht.
 */

/** Alle Knoepfe einer Leiste. */
function knoepfe(behaelter) {
    return Array.prototype.slice.call(behaelter.querySelectorAll('[role="tab"]'));
}

function tafelVon(knopf) {
    var id = knopf.getAttribute("aria-controls");

    return id ? document.getElementById(id) : null;
}

function waehle(behaelter, knopf, fokus) {
    knoepfe(behaelter).forEach(function (k) {
        var gewaehlt = k === knopf;
        k.setAttribute("aria-selected", gewaehlt ? "true" : "false");
        k.setAttribute("tabindex", gewaehlt ? "0" : "-1");

        var tafel = tafelVon(k);
        if (tafel) {
            if (gewaehlt) {
                tafel.removeAttribute("hidden");
            } else {
                tafel.setAttribute("hidden", "hidden");
            }
        }
    });

    if (fokus) {
        knopf.focus();
    }
}

/*
 * Ein Pflichtfeld in einer verborgenen Tafel bricht das Absenden ab, ohne dass
 * jemand sieht, warum: der Browser kann die Meldung nicht anzeigen. Deshalb
 * wird beim Absenden die Tafel mit dem ersten beanstandeten Feld nach vorne
 * geholt.
 */
function zeigeFehlerTafel(formular) {
    var schlecht = formular.querySelector(":invalid");
    if (!schlecht) {
        return;
    }

    var tafel = schlecht.closest('[role="tabpanel"]');
    if (!tafel) {
        return;
    }

    var behaelter = tafel.closest("[data-bw-reiter]");
    if (!behaelter) {
        return;
    }

    var knopf = behaelter.querySelector('[aria-controls="' + tafel.id + '"]');
    if (knopf) {
        waehle(behaelter, knopf, false);
        // Erst nach dem Aufdecken kann der Browser hinspringen.
        window.setTimeout(function () {
            schlecht.focus();
            if (typeof schlecht.reportValidity === "function") {
                schlecht.reportValidity();
            }
        }, 0);
    }
}

document.addEventListener("click", function (e) {
    var knopf = e.target.closest('[data-bw-reiter] [role="tab"]');
    if (!knopf) {
        return;
    }
    e.preventDefault();
    waehle(knopf.closest("[data-bw-reiter]"), knopf, false);
});

document.addEventListener("keydown", function (e) {
    var knopf = e.target.closest ? e.target.closest('[data-bw-reiter] [role="tab"]') : null;
    if (!knopf) {
        return;
    }

    var behaelter = knopf.closest("[data-bw-reiter]");
    var alle = knoepfe(behaelter);
    var i = alle.indexOf(knopf);
    var ziel = null;

    if (e.key === "ArrowRight") {
        ziel = alle[(i + 1) % alle.length];
    } else if (e.key === "ArrowLeft") {
        ziel = alle[(i - 1 + alle.length) % alle.length];
    } else if (e.key === "Home") {
        ziel = alle[0];
    } else if (e.key === "End") {
        ziel = alle[alle.length - 1];
    }

    if (ziel) {
        e.preventDefault();
        waehle(behaelter, ziel, true);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-bw-reiter]").forEach(function (behaelter) {
        var formular = behaelter.closest("form");
        if (!formular) {
            return;
        }

        /*
         * `invalid` steigt nicht auf, deshalb am Formular in der Erfassungs-
         * phase horchen. Das Absenden bricht der Browser selbst ab; hier wird
         * nur die richtige Tafel aufgedeckt.
         */
        formular.addEventListener("invalid", function () {
            zeigeFehlerTafel(formular);
        }, true);

        formular.addEventListener("submit", function () {
            if (!formular.checkValidity()) {
                zeigeFehlerTafel(formular);
            }
        });
    });
});
